import { ActionTree } from 'vuex';
import { RootState } from '@/store/store';
import { EAbTestingGroup } from '@/enums/ab-testing';
import {
  IOnboardingState,
  EOnboardingAction,
  EOnboardingMutation,
} from '@/onboarding-sidebar/store/onboarding.constants';

export const actions: ActionTree<IOnboardingState, RootState> = {
  [EOnboardingAction.SetOnboardingGroup]({ commit }, onboardingGroup: EAbTestingGroup) {
    commit(EOnboardingMutation.OnboardingGroup, onboardingGroup);
  },
  [EOnboardingAction.SetSentFirstDocument]({ commit }, sentFirstDocument: boolean) {
    commit(EOnboardingMutation.SetSentFirstDocument, sentFirstDocument);
  },
  [EOnboardingAction.ToggleOnboardingSidebar]({ commit }, value: boolean) {
    commit(EOnboardingMutation.ShowSidebar, value);
  },
};
